import type { ProfileRoleType } from '@strength/server-auth';

const ALL_TEAMS_TOKEN = 'all'; // teamIds === null
const NO_TEAMS_TOKEN = 'none'; // empty teamIds

// Stable Zero storageKey from the server-effective role + teamIds (the values
// the server transform gates on). Pure function of access, so an unchanged
// role/team yields an unchanged key and only a real change re-keys the store.
export function deriveRoleStorageKey(
  role: ProfileRoleType,
  teamIds: string[] | null,
): string {
  let teamsSegment: string;
  if (teamIds === null) {
    teamsSegment = ALL_TEAMS_TOKEN;
  } else if (teamIds.length === 0) {
    teamsSegment = NO_TEAMS_TOKEN;
  } else {
    teamsSegment = [...new Set(teamIds)].sort().join(',');
  }

  return `${role}:${teamsSegment}`;
}
